import { TagType } from '~/client/src/shared/enums/TagType'
import { ITag } from '~/client/src/shared/models/Tag'

// The selected tags the offered categories still list. A tag deleted while a
// picker is open drops out: it can't be unticked in the filter, so it must not
// count as applied (badge, panel selection and matching all read this).
export function getAppliedTagIds(
  selectedTagIds: string[],
  tagTypes: TagType[],
  tagsByType: Partial<Record<TagType, ITag[]>>,
): string[] {
  const known = new Set(
    tagTypes.flatMap(type => (tagsByType[type] || []).map(tag => tag.id)),
  )
  return selectedTagIds.filter(id => known.has(id))
}

// OR within a tag category, AND across categories, like every drill-down filter.
// Categories come from the offered tagTypes only: tagsByType lists some tags
// under more than one type (project roles also sit in the global+project role
// list), and each extra type would AND the same category again.
export function getUserTagFilterMatcher(
  selectedTagIds: string[],
  tagTypes: TagType[],
  tagsByType: Partial<Record<TagType, ITag[]>>,
  getUserIdsForTag: (tagId: string) => string[],
): (userId: string) => boolean {
  const selected = new Set(selectedTagIds)
  const allowedPerCategory = tagTypes
    .map(type => (tagsByType[type] || []).filter(tag => selected.has(tag.id)))
    .filter(tags => tags.length > 0)
    .map(tags => new Set(tags.flatMap(tag => getUserIdsForTag(tag.id))))

  return userId => allowedPerCategory.every(ids => ids.has(userId))
}
